import { buildUrl } from '@cc-shopping/utils/urlBuilder';
import type { ParamMap } from 'urlcat';

export const getEntryPointUrl = (overrideParams?: ParamMap) => {
  return buildUrl('/credit-cards/cardfinder', { ...overrideParams });
};
